import React from 'react';

const InvoiceDeliverySection = ({ formData, onChange }) => {
  const options = [
    {
      value: 'email',
      label: 'E-post',
      description: 'Faktura sendes til din registrerte e-postadresse som PDF-vedlegg.',
    },
    {
      value: 'post',
      label: 'Post',
      description: 'Faktura sendes til din registrerte postadresse. Leveringstid 3-5 virkedager.',
    },
    {
      value: 'portal',
      label: 'Kundeportal',
      description: 'Faktura er tilgjengelig i din konto under abonnementsportalen.',
    },
  ];

  return (
    <div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '22px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '8px', letterSpacing: '0.02em' }}>
        Fakturaleveranse
      </h2>
      <p style={{ fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 400, color: 'var(--color-muted-foreground)', marginBottom: '24px', lineHeight: 1.6 }}>
        Velg hvordan du onsker a motta fakturaer.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {options?.map(opt => (
          <label
            key={opt?.value}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '16px',
              padding: '16px',
              border: formData?.invoiceDelivery === opt?.value
                ? '2px solid var(--color-primary)'
                : '2px solid rgba(156, 163, 175, 0.2)',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer',
              transition: 'border-color 200ms ease-out',
              background: formData?.invoiceDelivery === opt?.value ? 'rgba(0, 79, 152, 0.06)' : 'transparent',
            }}
          >
            <input
              type="radio"
              name="invoiceDelivery"
              value={opt?.value}
              checked={formData?.invoiceDelivery === opt?.value}
              onChange={onChange}
              style={{ marginTop: '3px', accentColor: 'var(--color-primary)', flexShrink: 0 }}
            />
            <div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 500, color: 'var(--color-foreground)', marginBottom: '4px' }}>
                {opt?.label}
              </div>
              <div style={{ fontFamily: 'var(--font-caption)', fontSize: '13px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.5 }}>
                {opt?.description}
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default InvoiceDeliverySection;
